/**
 * Arquivo de definição e configuração de módulos da aplicação.
 */

var app = angular.module("avlib", ["ngMaterial", "ngSanitize", 

    // Copy to Clipboard from https://www.npmjs.com/package/angular-clipboard
	"angular-clipboard",
]);

